import { render, staticRenderFns } from "./ProductAttr.vue?vue&type=template&id=c51490c6&scoped=true&"
import script from "./ProductAttr.vue?vue&type=script&lang=js&"
export * from "./ProductAttr.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttr.vue?vue&type=style&index=0&id=c51490c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51490c6",
  null
  
)

export default component.exports